import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TopNav } from "@/components/TopNav";
import { Toaster } from "@/components/ui/sonner";
import Overview from "@/pages/Overview";
import InvoiceCapture from "@/pages/InvoiceCapture";
import AskTheData from "@/pages/AskTheData";
import UserGuide from "@/pages/UserGuide";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[#EEF1EF] font-body">
        <TopNav />
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/invoice-capture" element={<InvoiceCapture />} />
          <Route path="/ask-the-data" element={<AskTheData />} />
          <Route path="/user-guide" element={<UserGuide />} />
        </Routes>
      </div>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
